<template>
  <div class="fill-height">
    <div id="onlyoffice_viewer"></div>
    <ErrorAlert v-if="error"
                :error="error">
    </ErrorAlert>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {find} from 'lodash';
import onlyofficeService from '../../../services/onlyofficeService';
import ErrorAlert from '../../../components/ErrorAlert.vue';

export default {
  name: 'view-powerpoint-presentation',
  components: {ErrorAlert},
  props: {
    presentation: {
      type: Object,
      required: true,
    },
    session: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      docEditor: null,
      error: null,
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    mode() {
      /*if (['edit', 'view'].includes(this.$route.query.mode)) {
        return this.$route.query.mode;
      }*/
      return 'view';
    },
    file() {
      return find(this.presentation.files, f => {
        return ['presentation.pptx', 'presentation.ppt'].includes(f.path)
      })
    },
    callbackURL() {
      if (window.config.env === 'local') {
        return `https://ngrok.mobilelocker.com/webhooks/onlyoffice/callback`;
      }
      return `${window.config.appURL}/webhooks/onlyoffice/callback`;
    },
  },
  async mounted() {
    await this.initOnlyOffice();
  },
  methods: {
    async initOnlyOffice() {
      try {
        const config = await onlyofficeService.initConfig(this.team, this.user, this.presentation, this.file, this.mode, 'slide', this.callbackURL);
        this.docEditor = await onlyofficeService.initDocEditor(config);
      } catch (error) {
        console.log(`OnlyOffice Initialization error: `, error.message);
        this.error = {
          message: 'Presentation mode is not available. Contact support@mobilelocker.com'
        };
      }
    }
  }
}
</script>
